import React from 'react';
import { connect } from 'react-redux';
import { CFCProps } from 'types';
import SearchItem from './searchItem';

const ResultsBox: React.FC<Props> = (props) => {
  const { jobIdItems, userRefItems, onItemClick, noResult } = props;
  return (
    <>
      {noResult ? (
        <SearchItem label="No results found" item={{}} clickable={false} />
      ) : (
        <>
          {jobIdItems.map((item: any, inx: number) => {
            return (
              <SearchItem
                key={inx}
                customClassName={`${
                  inx === jobIdItems.length - 1
                    ? 'search-suggestion-last-item'
                    : ''
                }`}
                label={`${item.external_id} (${item.user_reference})`}
                item={item}
                onItemClick={(item: any) => onItemClick(item, 'jobId')}
                clickable={true}
              />
            );
          })}
          {userRefItems.map((uRef: any, inx: number) => {
            return (
              <SearchItem
                key={inx}
                label={uRef.user_reference}
                item={uRef}
                onItemClick={(item: any) => onItemClick(item, 'userRef')}
                clickable={true}
              />
            );
          })}
        </>
      )}
    </>
  );
};

ResultsBox.displayName = 'ResultsBox';

const connector = connect();

type OwnProps = {
  jobIdItems: Array<any>;
  userRefItems: Array<any>;
  onItemClick: Function;
  noResult: boolean;
};

type Props = CFCProps<typeof connector> & OwnProps;

export default React.memo(connector(ResultsBox));
